export const variableRegex = /\{.*?\}/g;

export const effortLevels = [
  {
    value: "very-low",
    label: "Very low effort",
  },
  {
    value: "low",
    label: "Low effort",
  },
  {
    value: "neutral",
    label: "Neutral",
  },
  {
    value: "high",
    label: "High effort",
  },
  {
    value: "very-high",
    label: "Very high effort",
  },
];

export const extractCustomVariables = (prompt: string) => {
  const matchedVariables =
    prompt
      .match(variableRegex)
      ?.map(matchedVariable => matchedVariable?.slice(1, -1)) || [];
  const customVariables = matchedVariables.length
    ? [...new Set(matchedVariables)]
    : ["not_specified"];
  return customVariables;
};

export const checkIfVariableIsInvalid = (variable?: string) =>
  variable && /\s/.test(variable);

export const formatCustomVariableErrorMessage = (variable?: string) =>
  variable
    ? `Invalid variable: ${variable}. Try ${variable?.split(" ")?.join(".")}`
    : "";

export const extractUrlVariables = (url: string) => {
  const variablePattern = /<([^>]+)>/g;
  const matchedVariables =
    url
      .match(variablePattern)
      ?.map(matchedVariable => matchedVariable.slice(1, -1)) || [];
  return [...new Set(matchedVariables)];
};

export const extractBodyVariables = (body: string) => {
  const variablePattern = /<([^>]+)>/g;
  const matchedVariables =
    body
      .match(variablePattern)
      ?.map(matchedVariable => matchedVariable.slice(1, -1)) || [];
  return [...new Set(matchedVariables)];
};

export const extractHeadersVariables = (
  headers: Array<{key?: string; value?: string}>,
) => {
  const variablePattern = /<([^>]+)>/g;
  const allVariables: string[] = [];

  headers?.forEach(header => {
    if (header.value) {
      const matchedVariables =
        header.value
          .match(variablePattern)
          ?.map(matchedVariable => matchedVariable.slice(1, -1)) || [];
      allVariables.push(...matchedVariables);
    }
  });

  return [...new Set(allVariables)];
};
